var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentalAntibioticGuide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 674.9 494.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #d5e4ed;\r\n      }\r\n\r\n      .st1 {\r\n        fill: url(#radial-gradient1);\r\n      }\r\n\r\n      .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23, .st24, .st25, .st26 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .st27 {\r\n        fill: url(#linear-gradient2);\r\n      }\r\n\r\n      .st2 {\r\n        fill: url(#linear-gradient9);\r\n      }\r\n\r\n      .st3 {\r\n        fill: url(#linear-gradient10);\r\n      }\r\n\r\n      .st28 {\r\n        fill: #3d6a97;\r\n      }\r\n\r\n      .st4 {\r\n        fill: url(#linear-gradient14);\r\n      }\r\n\r\n      .st4, .st9, .st10, .st29, .st11, .st14, .st15, .st18, .st21, .st25, .st26 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .st4, .st9, .st10, .st11, .st14, .st21, .st26 {\r\n        opacity: .5;\r\n      }\r\n\r\n      .st4, .st9, .st10, .st14, .st21, .st26 {\r\n        mix-blend-mode: screen;\r\n      }\r\n\r\n      .st30 {\r\n        fill: #e7eff5;\r\n      }\r\n\r\n      .st31 {\r\n        fill: #002861;\r\n      }\r\n\r\n      .st32 {\r\n        fill: #003785;\r\n      }\r\n\r\n      .st5 {\r\n        fill: url(#radial-gradient3);\r\n      }\r\n\r\n      .st33 {\r\n        fill: url(#linear-gradient1);\r\n      }\r\n\r\n      .st34 {\r\n        fill: #013d8d;\r\n      }\r\n\r\n      .st35 {\r\n        fill: #7ea0b7;\r\n      }\r\n\r\n      .st36 {\r\n        fill: #7c9eb4;\r\n      }\r\n\r\n      .st6 {\r\n        fill: url(#radial-gradient2);\r\n      }\r\n\r\n      .st7 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st37 {\r\n        fill: #e9f1f6;\r\n      }\r\n\r\n      .st38 {\r\n        fill: #6c8c9f;\r\n      }\r\n\r\n      .st39 {\r\n        fill: #dee9f1;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #4e83ca;\r\n      }\r\n\r\n      .st9 {\r\n        fill: url(#linear-gradient16);\r\n      }\r\n\r\n      .st10 {\r\n        fill: url(#linear-gradient15);\r\n      }\r\n\r\n      .st40 {\r\n        fill: #92b2c9;\r\n      }\r\n\r\n      .st11, .st18 {\r\n        fill: #f6f6fa;\r\n        mix-blend-mode: soft-light;\r\n      }\r\n\r\n      .st12 {\r\n        fill: #034791;\r\n      }\r\n\r\n      .st13 {\r\n        fill: url(#linear-gradient8);\r\n      }\r\n\r\n      .st41 {\r\n        fill: #001439;\r\n      }\r\n\r\n      .st42 {\r\n        fill: #195da8;\r\n      }\r\n\r\n      .st43 {\r\n        fill: #fdfeff;\r\n      }\r\n\r\n      .st44 {\r\n        fill: #204698;\r\n      }\r\n\r\n      .st45 {\r\n        fill: url(#linear-gradient4);\r\n      }\r\n\r\n      .st46 {\r\n        fill: #003989;\r\n      }\r\n\r\n      .st14 {\r\n        fill: url(#linear-gradient17);\r\n      }\r\n\r\n      .st15 {\r\n        fill: url(#linear-gradient6);\r\n      }\r\n\r\n      .st15, .st25 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .st47 {\r\n        fill: #c4e5f0;\r\n      }\r\n\r\n      .st48 {\r\n        fill: #88acc4;\r\n      }\r\n\r\n      .st16 {\r\n        fill: url(#linear-gradient11);\r\n      }\r\n\r\n      .st49 {\r\n        fill: url(#linear-gradient5);\r\n      }\r\n\r\n      .st17 {\r\n        fill: url(#linear-gradient7);\r\n      }\r\n\r\n      .st50 {\r\n        fill: #6794b4;\r\n      }\r\n\r\n      .st18 {\r\n        opacity: .6;\r\n      }\r\n\r\n      .st19 {\r\n        fill: url(#linear-gradient12);\r\n      }\r\n\r\n      .st51 {\r\n        fill: #161615;\r\n      }\r\n\r\n      .st20 {\r\n        fill: url(#radial-gradient);\r\n      }\r\n\r\n      .st52 {\r\n        fill: #1d2428;\r\n      }\r\n\r\n      .st21 {\r\n        fill: url(#linear-gradient18);\r\n      }\r\n\r\n      .st22 {\r\n        fill: url(#linear-gradient3);\r\n      }\r\n\r\n      .st23 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .st24 {\r\n        fill: #79a5d5;\r\n      }\r\n\r\n      .st25 {\r\n        fill: #8093c8;\r\n        opacity: .3;\r\n      }\r\n\r\n      .st26 {\r\n        fill: url(#linear-gradient13);\r\n      }\r\n\r\n      .st53 {\r\n        fill: #1566bd;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -207,
    y1: 16.9,
    x2: -207,
    y2: -32,
    gradientTransform: "translate(66 5) rotate(-160.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e64b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93b2e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -206.5,
    cy: 936.6,
    fx: -206.5,
    fy: 936.6,
    r: 31.5,
    gradientTransform: "translate(360.2 -810.8) rotate(-160.2) scale(1 -.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3c5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a7b1dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b9dd4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -190.4,
    y1: 17.2,
    x2: -190.4,
    y2: -32.7,
    gradientTransform: "translate(240 -128.3) rotate(-90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5b9e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -189.8,
    y1: 15.5,
    x2: -189.8,
    y2: -31,
    gradientTransform: "translate(239.5 -127.9) rotate(-90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfccec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: -189.9,
    cy: -2013.1,
    fx: -189.9,
    fy: -2013.1,
    r: 17.6,
    gradientTransform: "translate(-837.8 2516.6) rotate(-160.2) scale(1 -1.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3c5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b9dd4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: -245.6,
    y1: 109.9,
    x2: -245.6,
    y2: 81.7,
    gradientTransform: "translate(77.3 -57.5) rotate(-177.9) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: -246,
    cy: 1059.2,
    fx: -246,
    fy: 1059.2,
    r: 18.2,
    gradientTransform: "translate(108.6 -923.7) rotate(-177.9) scale(1 -.9)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: -236.2,
    y1: 110.1,
    x2: -236.2,
    y2: 81.3,
    gradientTransform: "translate(405.5 -189.4) rotate(-90) scale(1 -1)",
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: -235.9,
    y1: 109.1,
    x2: -235.9,
    y2: 82.3,
    gradientTransform: "translate(405.2 -189.1) rotate(-90) scale(1 -1)",
    xlinkHref: "#linear-gradient2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: -236.5,
    cy: -1932,
    fx: -236.5,
    fy: -1932,
    r: 10.1,
    gradientTransform: "translate(-20.2 2610.4) rotate(-177.9) scale(1 -1.3)",
    xlinkHref: "#radial-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 580.8,
    y1: 466.9,
    x2: 661.8,
    y2: 466.9,
    gradientTransform: "translate(-172.2 -134.3) rotate(-4.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d9f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 573.4,
    y1: 460,
    x2: 673.2,
    y2: 437.5,
    gradientTransform: "translate(-172.2 -134.3) rotate(-4.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d9f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92a2e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 617.5,
    y1: 453.6,
    x2: 627.3,
    y2: 423.5,
    gradientTransform: "translate(-172.2 -134.3) rotate(-4.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cad5ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 617.8,
    y1: 449.3,
    x2: 628,
    y2: 418,
    xlinkHref: "#linear-gradient8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 580.6,
    y1: 443.9,
    x2: 667,
    y2: 424.5,
    xlinkHref: "#linear-gradient7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 558.5,
    y1: 574.5,
    x2: 634.4,
    y2: 558.3,
    gradientTransform: "translate(-172.2 -134.3) rotate(-4.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8e5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9abdec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 646.2,
    y1: 569,
    x2: 690.6,
    y2: 559.6,
    gradientTransform: "translate(-172.2 -134.3) rotate(-4.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbbdec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 662.9,
    y1: 562.7,
    x2: 677.1,
    y2: 562.7,
    gradientTransform: "translate(-172.2 -134.3) rotate(-4.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 587,
    y1: 623.3,
    x2: 587,
    y2: 470.7,
    xlinkHref: "#linear-gradient13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: 53.2,
    y1: -56,
    x2: 53.2,
    y2: -64.8,
    gradientTransform: "translate(533.7 85.9) rotate(74.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6e8e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: 30.2,
    y1: -39.9,
    x2: 70,
    y2: -39.9,
    gradientTransform: "translate(533.7 85.9) rotate(74.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6e8e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: 316.2,
    y1: -109.3,
    x2: 316.2,
    y2: -115,
    gradientTransform: "translate(307.3 -85.1) rotate(58.3)",
    xlinkHref: "#linear-gradient15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: 301.6,
    y1: -98.9,
    x2: 327.2,
    y2: -98.9,
    gradientTransform: "translate(307.3 -85.1) rotate(58.3)",
    xlinkHref: "#linear-gradient16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M105.6,156.7c7.3-32.6,34.5-55.5,73.6-60.4,99.4-12.5,66.3-35.5,129.2-65.7,97.6-47,101.4,68.1,198.8,57.8,59.7-6.4,152.3,48.1,100.4,106.5-59.2,66.6-14.1,89-38.3,151.1-27.9,72.2-89.7,61.7-133.1,69.4-46,8.2-70.4,69.1-137.1,59.1-52.9-7.9-41.1-60.8-157.6-70.3-64.8-5.3-105.8-73-71.2-118.1,53.7-70.1,23.7-77.7,35.2-129.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M618.5,456.4c3.1,0,5.6,2.4,5.6,5.3h0c0,2.9-2.5,5.3-5.6,5.3H36.2c-3.1,0-5.6-2.4-5.6-5.3h0c0-2.9,2.5-5.3,5.6-5.3h582.4,0ZM667.4,456.4c-2.9,0-5.3,2.4-5.3,5.3h0c0,2.9,2.4,5.3,5.3,5.3h0c2.9,0,5.3-2.4,5.3-5.3h0c0-2.9-2.4-5.3-5.3-5.3h0ZM640.7,456.4c-2.9,0-5.3,2.4-5.3,5.3h0c0,2.9,2.4,5.3,5.3,5.3h8.8c2.9,0,5.3-2.4,5.3-5.3h0c0-2.9-2.4-5.3-5.3-5.3h-8.8ZM4.9,456.4c-1.4,0-2.6,2.4-2.6,5.3h0c0,2.9,1.2,5.3,2.6,5.3h15.1c1.4,0,2.6-2.4,2.6-5.3h0c0-2.9-1.2-5.3-2.6-5.3H4.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M258.2,40.4s6.8,1.6,13.1,5.6c0,0,11.9,8.9,5.5,26.7-6.2,17.2-21.9,17.7-21.9,17.7,0,0-7-1-13-4.7l16.3-45.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M256.2,38.8s7,1.6,13.6,5.8c0,0,12.4,9.3,5.7,27.7-6.4,17.9-22.7,18.3-22.7,18.3,0,0-7.2-1.1-13.5-4.9l16.9-46.9h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 247.8,
    cy: 62.2,
    rx: 24.9,
    ry: 17.8,
    transform: "translate(105.4 274.3) rotate(-70.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 247.2,
    cy: 62,
    rx: 23.2,
    ry: 16.6,
    transform: "translate(105.2 273.6) rotate(-70.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.3,39.7l-18.1,46.2c-1.8-.6-3.2-1.2-4.8-2.4l17.2-45.6s3.8.7,4.3.9c.8.3.9.5,1.4.8h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "252.7 38 257 39 238.1 85.1 235.5 83.6 252.7 38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M266.1,86.5l-2.7.8-10.4-3.7s-6.2,4.6-13.6,2.1c0,0,5,3.3,13.5,4.9,0,0,6.9.2,13.2-4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M278.2,57.5l-12-5.7s-.8-5.7-5.1-10.1l11.1,5s5,5.6,6,10.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M311.6,33s4-.3,8.2.8c0,0,8.1,2.8,7.7,13.7-.4,10.6-8.9,13.5-8.9,13.5,0,0-4,.6-8-.3l1-27.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M310.2,32.4s4.2-.3,8.5.8c0,0,8.4,2.9,8,14.2-.4,11-9.3,14.1-9.3,14.1,0,0-4.2.7-8.3-.3l1-28.8h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st45",
    cx: 309.8,
    cy: 46.8,
    rx: 14.4,
    ry: 10.3,
    transform: "translate(251.7 354.7) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st49",
    cx: 309.5,
    cy: 46.8,
    rx: 13.4,
    ry: 9.6,
    transform: "translate(251.4 354.4) rotate(-87.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.6,32.6l-1.8,28.6c-1.1,0-2,0-3-.5l1.4-28.1s2.2-.3,2.5-.3c.5,0,.6.1.9.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "308.2 32.7 310.7 32.4 308.3 61.1 306.7 60.7 308.2 32.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M324.1,57l-1.3.9-6.4-.2s-2.6,3.6-7.1,3.6c0,0,3.3.9,8.3.3,0,0,3.8-1.1,6.5-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.6,38.9l-7.6-1s-1.4-3-4.6-4.6l7,.8s3.7,2.2,5.2,4.9h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M56.3,309.4h0c0,.9.2,1.7.3,2.5v.2c.2.8.4,1.5.6,2.3v.3c.3.7.6,1.3.9,2l.2.5c.3.6.7,1.2,1,1.7l.4.6c.4.5.8,1,1.2,1.5l.5.6c.4.5.9.9,1.4,1.4l.6.5c.3.3.7.5,1.1.8l-1.1-.7v17.3c-9.9-9.5-7.2-33.5-7.2-33.5h0v2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M595.5,248.1h0c0,.5,0,1.1,0,1.6,0,6.5-3.2,13.1-9.6,16.9l-298.8,179.9c-6.3,3.8-14.2,3.8-20.4,0l-101.1-61.2,100.1,60.7v17.4l-201.6-122.2c.5.5,1.1.9,1.7,1.3l200.9,121.6c6.3,3.8,14.1,3.8,20.4,0l298.8-179.9c12.7-7.7,9.6-36.1,9.6-36.1h0ZM583.7,285.5l-294,177.1v-17.4l294-177.1v17.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "289.7 445.1 583.7 268.1 583.7 285.5 289.7 462.6 289.7 445.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M538.7,234l-33.3-20.2,17.6-10.6v-6.7l-18.3-11.1,1.5-.9,60,36.3-7.7-4.6c-6.4,6.2-13,12.1-19.8,17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M426,137.8l-23.1,14-42.7-25.8L67.7,303.4l37.3,22.5c-16.8-5-33.1-11.3-48.6-19.2v2.6-2.2c.3-6.2,3.4-12.4,9.5-16.1L364.7,111.2c6.3-3.8,14.2-3.8,20.4,0l60.4,36.6-1.5.9-18.1-10.9h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M63.5,323.3c.4.3.8.6,1.2.8h0c-.4-.3-.7-.6-1.1-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M61.5,321.5c.4.5.9.9,1.4,1.4-.5-.4-1-.9-1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M61,320.9c-.4-.5-.8-1-1.2-1.5.4.5.8,1,1.2,1.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "266.7 446.6 165.6 385.4 165.5 385.3 266.7 446.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M56.9,244.9c-.3,1.1-.4,2.1-.5,3.2,0,.6,0,1.1,0,1.7,0-1.6.2-3.3.6-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M56.7,311.9c-.2-.8-.3-1.6-.3-2.5,0,.8.2,1.7.3,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M59.5,318.8c-.4-.6-.7-1.1-1-1.7.3.6.7,1.2,1,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M58.2,316.6c-.3-.7-.6-1.3-.8-2,.2.7.5,1.3.8,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M57.3,314.3c-.2-.7-.4-1.5-.6-2.3.2.8.4,1.5.6,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M595.5,249.8c0,6.5-3.2,13.1-9.6,16.9l-298.8,179.9c-6.3,3.8-14.2,3.8-20.4,0l-101.2-61.3-100.8-61.1c-.4-.3-.8-.5-1.2-.8l-.6-.5c-.5-.4-1-.9-1.4-1.4l-.5-.6c-.4-.5-.8-1-1.2-1.5l-.4-.6c-.4-.6-.7-1.1-1-1.7l-.2-.5c-.3-.7-.6-1.3-.8-2v-.3c-.3-.7-.5-1.5-.7-2.3v-.2c-.2-.8-.3-1.6-.3-2.5h0v-2.6c15.5,7.9,31.8,14.2,48.6,19.2l177.5,107.4,292.5-177.4-36.3-22c6.8-5.7,13.4-11.6,19.8-17.8l7.7,4.6,19.9,12c4.8,2.9,7.8,7.3,8.9,12.1.4,1.6.6,3.2.6,4.9h-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "64.6 324.1 64.7 324.2 165.5 385.3 165.6 385.4 265.7 446.1 265.7 463.5 64.1 341.3 63.4 340.9 63.4 340.7 63.4 323.4 64.6 324.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M538.7,234l-33.3-20.2-24.1,14.6-97-58.7v-6.7l18.6-11.3-42.7-25.8L67.7,303.4l37.3,22.6,177.5,107.4,292.5-177.4-36.3-22h0ZM330.7,373.2l-71.4-44.7,6.8-3.2,70.9,44.3-6.3,3.7h0ZM342.8,366.6l-162.3-102.6,6.8-3.2,161.8,102.2-6.3,3.7h0ZM354.2,359.1l-162.3-102.6,6.8-3.2,161.8,102.2-6.3,3.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "384.2 169.7 384.2 163 481.2 221.7 523 196.5 523 203.2 505.3 213.8 481.2 228.4 384.2 169.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M511.7,179.3c.5-.8.8-1.6,1.1-2.4-.3.8-.7,1.6-1.1,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M507.2,183.9c.9-.5,1.7-1.2,2.4-1.8-.7.7-1.5,1.3-2.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M509.8,181.8c.6-.7,1.2-1.4,1.7-2.1-.5.7-1,1.5-1.7,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M513,167.9c-.3-.9-.7-1.7-1.2-2.6.5.8.9,1.7,1.2,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M513.7,170.8c0-.9-.3-1.8-.6-2.7.3.9.5,1.8.6,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M513,176.5c.3-.9.5-1.8.6-2.7,0,.9-.3,1.8-.6,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M513.7,173.8c0-1,0-1.9,0-2.9v2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M511.7,165.1c-.5-.8-1.1-1.6-1.8-2.3.7.7,1.3,1.5,1.8,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M503.3,175.2l-7.8,4.7-51.6-31.2,1.5-.9,8.1-4.9c7.3-5.1,15.3-5.1,24.9.3l28.7,17.5c1,.6,1.9,1.3,2.7,2.1.3,4.7-1.9,9.6-6.5,12.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M495.6,179.9l7.8-4.7c4.6-2.8,6.8-7.7,6.5-12.4h0c.7.7,1.3,1.5,1.8,2.3v.2c.6.8,1,1.7,1.3,2.6v.2c.4.9.6,1.8.7,2.7h0v3h0c0,.9-.3,1.8-.6,2.7v.3c-.4.8-.8,1.6-1.2,2.4l-.2.4c-.5.7-1,1.5-1.7,2.1l-.3.3c-.7.7-1.5,1.3-2.4,1.8l-1,.6-1.5.9-9.1-5.5h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M523,196.5l-18.3-11.1-9.1-5.5-51.6-31.2-18.1-10.9-23.1,14-18.6,11.2,97,58.7,41.7-25.2h.1ZM469,197.2c0-4.9,7.4-8.8,16.6-8.8s16.6,3.9,16.6,8.8-7.4,8.8-16.6,8.8-16.6-3.9-16.6-8.8ZM440.5,159.6c0,4.9-7.4,8.8-16.6,8.8s-16.6-3.9-16.6-8.8,7.4-8.8,16.6-8.8,16.6,3.9,16.6,8.8ZM449.7,164.3c.4,0,26.7,16.8,26.7,16.8l-22.8,13.2-27.1-16.9s22.9-13.2,23.2-13.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M485.6,188.4c9.2,0,16.6,3.9,16.6,8.8s-7.4,8.8-16.6,8.8-16.6-3.9-16.6-8.8,7.4-8.8,16.6-8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M440.5,159.6c0,4.9-7.4,8.8-16.6,8.8s-16.6-3.9-16.6-8.8,7.4-8.8,16.6-8.8,16.6,3.9,16.6,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M476.5,181.1l-22.8,13.2-27.1-16.9s22.9-13.2,23.2-13.2,26.7,16.8,26.7,16.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "297.1 193.3 320.2 180.1 347 196.9 324.2 210.2 297.1 193.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "354.3 205.9 361.2 202.6 485.7 281.2 479.3 284.9 354.3 205.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "473.6 287.8 467.2 291.5 395.3 246.5 402.2 243.2 473.6 287.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "259.2 218 282.5 204.8 309.2 221.6 286.3 234.9 259.2 218"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "316.2 230.7 323.2 227.4 447.7 306.1 441.3 309.7 316.2 230.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "364.2 268 435.5 312.6 429.2 316.3 357.3 271.3 364.2 268"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "242.8 229.5 269.6 246.3 246.8 259.5 219.7 242.7 242.8 229.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "283.3 252.3 407.8 330.9 401.6 334.6 276.5 255.6 283.3 252.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "319 298 389.8 342.3 383.6 346 312.2 301.3 319 298"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "180.7 264.1 187.5 260.8 349.2 363 342.8 366.6 180.7 264.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "192.1 256.6 198.8 253.3 360.6 355.5 354.2 359.1 192.1 256.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "259.3 328.4 266.2 325.2 337.1 369.5 330.7 373.2 259.3 328.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "302.2 397.1 230.8 352.4 237.6 349.2 308.5 393.5 302.2 397.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M273.7,119.9v-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M271.8,122.6l.4-.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M270.1,121.7c-.6-1.2-1.5-1.8-2.3-2.2,1.9-.6,5.4-1.5,6-.5v.3c-1.1,1-2.3,1.8-3.6,2.6v-.2h-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "270.7 124 270.7 124 270.7 124 270.7 124"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M271.1,123.5l.4-.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M272.7,121.7l.3-.5-.3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M273.2,120.7l.2-.4-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M273.7,119.5v.3l-.2.4-.2.4-.3.5-.3.5-.4.5-.4.5-.4.5-.4.4-.4.4h0c0-.6-.1-1.3-.5-2.1,1.3-.8,2.5-1.6,3.6-2.6h0v.2h-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "246.5 151 246.5 151 246.5 151 246.5 151"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.1,121.7c-.4.3-11.1,15.1-20.4,18.9-1.6.7-4.8-2.9-6.2-3h0c-4.6-6.8-10.6-8.9-10.6-9h0l33.3-9.7s.8,0,1.7.5c.8.4,1.7,1,2.3,2.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M246.5,151c.2-.8,1.7-5.8-2.5-12.4-.2-.3-.4-.6-.6-.9,1.4,0,4.6,3.6,6.2,3,9.3-3.8,20-18.6,20.4-18.9v.2c.5.7.6,1.5.6,2.1h0c0,1.1-.4,1.8-.4,1.8l-23.7,25.3h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M187.8,171.5c-34,20.8-72.9,44.7-85.4,52.3h0c-4.2-6.2-10.9-8.7-10.9-8.7l85.9-52.6s5.3.8,10.3,9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M243.3,137.5c-1.4.9-4.1,2.5-7.8,4.7h0c-4.4-6.2-11.2-8.5-11.2-8.5l-41.3,25.3,49.6-30.3h0s6,2.2,10.6,8.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M102.5,223.9h0c12.4-7.6,51.4-31.5,85.4-52.3h0c5.1,8.3,3.4,13.3,3.3,13.3l-85.9,52.6h0c0-.3,2.4-5.8-2.8-13.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M235.7,142.4v-.2c3.5-2.2,6.2-3.9,7.7-4.7h0c.2.4.4.7.6,1,4.2,6.6,2.7,11.7,2.5,12.4h0l-8.3,5.1s1.8-7.6-2.5-13.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M235.6,142.3h0v.2c-9.4,6-37.7,23.1-47.7,29.1h0c-5.1-8.3-10.3-9.1-10.3-9.1h0l5.7-3.5,41.3-25.3s6.8,2.3,11.2,8.5h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M187.8,171.6h0c10-6,38.3-23.2,47.8-29.2,4.3,6.2,2.5,13.7,2.5,13.7h0l-46.9,28.7h0s1.7-5.1-3.3-13.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.3,244.9l-.6.4-.6.3h.2c.4-.3.7-.5,1.1-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.5,223.8c-3.9,2.3-8.1,4.5-12.1,6.4-3.7-5.5-9-8.4-12.2-6.8l.8-.6,12.7-7.8s6.7,2.5,10.9,8.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M87,246c-1-.3-1.9-.7-2.7-1.4.9.6,1.8,1.1,2.7,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M90.9,230.9l-.5-.7c4-1.9,8.2-4.1,12.1-6.4h0c5.3,7.8,2.9,13.4,2.8,13.7h0c-1.4.9-3.6,2.2-5.8,3.5l-1,.6c-.3.2-.7.4-1,.6l-.9.5h0l-.8.5c-1.5.9-2.5,1.5-2.5,1.5h0c-.4.3-.7.4-1.1.6,2.8-2.4,2.3-8.7-1.3-14.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M90.4,230.2l.5.7c3.6,5.8,4.1,12.1,1.3,14.5h-.2c0,.1-.3.4-.3.4-1.3.8-3,.8-4.7.1-.9-.3-1.8-.8-2.7-1.4-2-1.4-4-3.4-5.6-6-3.8-6.1-4.2-12.8-.9-14.9h.3c3.2-1.8,8.5,1.1,12.2,6.7h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M521.2,284.7l-.7-10.3-40.3,2.9-40.3,2.9.7,10.3c-14.6,12.8-16.1,30.3-16.1,30.3l13.5,124.1s16.8,8.8,54.6,6c40.8-2.9,54.4-13.7,54.4-13.7l-5.5-124.9s-4-17-20.3-27.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M440.6,290.5s16.6,3.7,41.9,1.9c25.3-1.8,38.8-7.7,38.8-7.7l-.4-5.7-80.7,5.3.4,6.2h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M429.1,262.3l3.5,20.9s11.4,4.2,48.1,1.6c36.6-2.6,48.9-8.5,48.9-8.5l1.3-21.2s-17.6,4.5-53.9,7.1c-36.3,2.6-48,.2-48,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M429.1,262.3s47.2-15.5,101.8-7.3c0,0-17,4.5-53.9,7.1-36.9,2.7-48,.2-48,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M437.1,260l-2.1-5.1s42.8-11.4,90.4-7l-.8,7.5s-16,2.3-45.6,4.5c-29.6,2.1-41.8.2-41.8.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M435,254.9s17,1.3,44.7-.7,45.7-6.3,45.7-6.3l-.6,6.4s-14.7,3.9-45.8,6.1c-27.6,2-41.6.1-41.6.1l-2.4-5.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "434.3 282 431.7 263.9 433.1 263.8 435.3 281.9 434.3 282"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "443 283.5 440.2 265.4 441.6 265.3 444 283.4 443 283.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "452.3 283.8 449.7 265.7 451.1 265.6 453.3 283.8 452.3 283.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "462.2 283.8 459.6 265.7 461 265.6 463.2 283.7 462.2 283.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "514.4 279 513.4 260.8 514.7 260.7 515.4 278.9 514.4 279"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "473.7 283 471.7 264.8 473.2 264.7 474.7 282.9 473.7 283"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "488.7 281.9 487.1 263.7 488.3 263.6 489.7 281.8 488.7 281.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "524.5 276.2 524.2 257.9 525.7 257.8 525.5 276.1 524.5 276.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "502.6 280.9 501.1 262.7 502.5 262.6 503.6 280.9 502.6 280.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M426.1,335.6s23,4.8,54.8,3c5.8-.3,10.7,4.1,11,9.9l4.2,84.8c.3,5.5-3.8,10.3-9.2,10.9-11.7,1.3-32,1.7-49.7-6.2l-11.2-102.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M542.5,325.5s-6.9,5.4-18.9,9.2c-3,.9-5,3.9-4.7,7l6.2,86.3c.3,4.3,4.5,7.3,8.7,6.2,4.3-1.2,9.3-2.8,12.9-4.8l-4.2-103.8h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "533.5 440 527.9 322.5 539 318.1 543.5 435.9 533.5 440"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M440.7,293.7s-11.1,11.8-13.2,24.6l14.9,124.1s10.2,3.9,30.1,2l-8.2-128.7s.2-13.5,3.9-20.7c0,0-16.4-.7-27.5-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M427.6,318.3s13.5,3.3,37.1,2.2c0,0-2-13.6,3.5-25.6l-27.5-1.2s-11.1,12.4-13.2,24.6h.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M605.4,159.5h-.9c-6.9,1.1-13.4-3.2-15.1-10l-6.6-26.2-4.9-19.3c-1.7-6.7,2-13.6,8.5-16,7.4-2.7,15.6,1.5,17.7,9.2l12.3,45.4c2.1,7.8-3.1,15.7-11.1,16.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M582.9,123.4l-4.9-19.3c-1.7-6.7,2-13.6,8.5-16,7.4-2.7,15.6,1.5,17.7,9.2l4.7,17.5c-18.4-.9-26,8.6-26,8.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M603.7,95.8s-7.7,1.5-3.8,19.4,17,29.5,17,29.5c0,0-6.7-25.5-13.2-48.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M579.2,105.4s4.7,3.9,8.2,16.8c3.5,13,1.1,21.8,1.1,21.8l-9.4-38.7h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M612.5,145.9s-2.3.7-2.7,3.1c-.4,2.5.8,3.8.8,3.8,0,0,4.3-1.6,2-6.9h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M575.5,148.6l-.5.2c-4,1.9-8.8.4-11.1-3.4l-8.8-14.9-6.5-11c-2.3-3.8-1.3-8.7,2.3-11.4,4.1-3,9.9-1.9,12.5,2.4l15.9,25.7c2.7,4.4,1,10.2-3.7,12.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M555,130.5l-6.5-11c-2.3-3.8-1.3-8.7,2.3-11.4,4.1-3,9.9-1.9,12.5,2.4l6.1,9.9c-11.5,2.8-14.4,10.1-14.4,10.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M562.7,109.7s-4.5,2.3,1.2,12.6c5.7,10.3,15.9,15.1,15.9,15.1,0,0-8.8-14.5-17-27.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M549.4,120s3.6,1.5,8.1,8.9c4.5,7.3,4.7,13.2,4.7,13.2l-12.8-22.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M577.4,138.9s-1.3.9-1.1,2.4c.2,1.6,1.2,2.2,1.2,2.2,0,0,2.4-1.8,0-4.6h-.1Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalAntibioticGuide);
export default __webpack_public_path__ + "static/media/DentalAntibioticGuide.37e1b8538c85a53cdc088817163d2c63.svg";
export { ForwardRef as ReactComponent };